import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import 'dayjs/locale/it';
import {
  getCookie,
  setCookie,
} from 'packages/blu-booking/src/utility_objects/CookieManager';
import {
  removePointOfSale,
  removeService,
  removeStudio,
  selectPointOfSale,
  selectService,
  selectStudio,
  selectZoomValue,
  setUser,
  setSelectedDate,
  setClient,
} from '../../../utility_objects/StoreFunctions';
import {
  getPresenzeModoSalvato,
  getSoloOrarioSalvato,
  PresenzeModo,
  salvaPresenzeModo,
  salvaSoloOrario,
} from '../../../utility_objects/preferenzeCalendario';
import { StudiSelectedFiltersState } from './interface';

const initialState: StudiSelectedFiltersState = {
  view: getCookie('studioCalendarView') || 'Day',
  selectedDate: new Date(),
  selectedServices: [],
  selectedStudi: [],
  selectedUsers: [],
  zoom: {
    value: 150,
    interval: 60,
    slotCount: 4,
  },
  zoomValue: 150,
  // Scelte del riquadro Visualizzazione di questo calendario, ricordate per
  // PC per un anno nei cookie studioCalendarSoloOrario e
  // studioCalendarPresenzeModo: Ore «Tutte» e Presenze «Nessuno» di default,
  // indipendenti da quelle dell'agenda negozio.
  soloOrario: getSoloOrarioSalvato('studio'),
  presenzeModo: getPresenzeModoSalvato('studio'),
};

const StudioCalendarSlice = createSlice({
  name: 'BluBookingStudioCalendar',
  initialState,
  reducers: {
    StudioCalendarSetView: (
      state: StudiSelectedFiltersState,
      action: PayloadAction<'Day' | 'TimelineDay'>
    ) => {
      state.view = action.payload;
      setCookie('studioCalendarView', action.payload);
    },
    StudioCalendarSetSoloOrario(
      state: StudiSelectedFiltersState,
      action: PayloadAction<boolean>
    ) {
      state.soloOrario = action.payload;
      salvaSoloOrario('studio', action.payload);
    },
    StudioCalendarSetPresenzeModo(
      state: StudiSelectedFiltersState,
      action: PayloadAction<PresenzeModo>
    ) {
      state.presenzeModo = action.payload;
      salvaPresenzeModo('studio', action.payload);
    },

    StudioCalendarSetSelectedDate: setSelectedDate,
    StudioCalendarSelectZoomValue: selectZoomValue,
    // ? ADD
    StudioCalendarSelectPointOfSale: selectPointOfSale,
    StudioCalendarSetService: selectService,
    StudioCalendarSelectStudio: selectStudio,
    StudioCalendarSetUser: setUser,
    StudioCalendarSetClient: setClient,
    // ? REMOVE
    StudioCalendarRemoveStudio: removeStudio,
    StudioCalendarRemoveService: removeService,
    StudioCalendarRemovePointOfSale: removePointOfSale,

    StudioCalendarResetSelected: (
      state: StudiSelectedFiltersState,
      action: PayloadAction<string>
    ) => {
      return { ...state, [action.payload]: [] };
    },
    StudioCalendarReset: () => initialState,
  },
});

export const {
  StudioCalendarSetView,
  StudioCalendarSetSoloOrario,
  StudioCalendarSetPresenzeModo,
  StudioCalendarSetSelectedDate,
  StudioCalendarSelectZoomValue,
  StudioCalendarSelectPointOfSale,
  StudioCalendarSetService,
  StudioCalendarSelectStudio,
  StudioCalendarRemoveStudio,
  StudioCalendarRemoveService,
  StudioCalendarRemovePointOfSale,
  StudioCalendarResetSelected,
  StudioCalendarSetUser,
  StudioCalendarSetClient,
  StudioCalendarReset,
} = StudioCalendarSlice.actions;

export default StudioCalendarSlice.reducer;
